module.exports = __webpack_public_path__ + "media/v2/components/blocks/IconGame/shared/img/survivor/yardage-b2257834b31f632d0d5a9b13325b3861.svg";